<template>
  <div>
    <!-- 客户商品管理番号 -->
    <el-dialog :visible.sync="dialogVisible" width="1200px" :title="client_sku_code">
      <div class="table">
        <ol>

          <!-- 商品链接 -->
          <li>
            {{ $t('message.ProductLink') }}
          </li>
          <!-- 商品图片 -->
          <li>
            {{ $t('message.productPicture') }}
          </li>
          <!-- SKU -->
          <li>
            SKU
          </li>
          <!-- 工厂 -->
          <li>
            {{ $t('message.factory') }}
          </li>
          <!-- 状态 -->
          <li>
            {{ $t('message.status') }}
          </li>
          <!-- 操作 -->
          <li>
            {{ $t('message.operation') }}
          </li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">

          <!-- 商品链接 -->
          <li>
            <div>
              <p style="margin: 20px 0; ">
                <a :href="`https://www.rakumart.com/ProductDetails?goods_id=${item.link.goods_id}&fromPlatform=${item.link.from_platform}`"
                  target="_blank" rel="noopener noreferrer" class="a-link">
                  {{
                    `https://www.rakumart.com/ProductDetails?goods_id=${item.link.goods_id}&fromPlatform=${item.link.from_platform}`
                  }}
                </a>
              </p>
              <a :href="item.link.goods_url" target="_blank" rel="noopener noreferrer" class="a-link">
                {{ item.link.goods_url }}
              </a>
            </div>
          </li>
          <!-- 商品图片 -->
          <li>
            <el-image style="width:80px;height: 80px;border-radius: 6px;" :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- SKU -->
          <li>
            <div>
              <p v-for="(sku, skuIndex) in item.item_sku.detail" :key="skuIndex">{{ sku.key }}:{{ sku.value }}</p>
            </div>
          </li>
          <!-- 工厂 -->
          <li>
            {{ item.item_sku.item.shop_name }}
          </li>
          <!-- 状态 -->
          <li>
            {{ item.item_sku.is_on_sale > 0 ? '有库存' : '已下架' }}
          </li>
          <!-- 操作 -->
          <li>
            <el-button type="primary" @click="replaceManagementNumber(item)"> {{ $t('message.replaceManagementNumber')
            }}</el-button>
          </li>
        </ul>
        <div class="nodata" v-if="list == false">暂无数据</div>
      </div>
    </el-dialog>
    <!-- 管理番号 -->
    <el-dialog :visible.sync="codeDialogVisible" width="600px" :title="$t('message.managementDesignation')">
      <div style="margin: 0 30px;">
        <el-input type="textarea" v-model="datas.client_sku_code"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="singleLinkUpdateClientCode">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      codeDialogVisible: false,
      client_sku_code: '',
      user_id: '',
      list: [],
      datas: {
        client_sku_code: '',
      },
    };
  },
  methods: {
    // 显示输入框
    replaceManagementNumber(item) {
      this.datas.client_product_link_id = item.id
      this.datas.sys_code = item.sys_code
      this.datas.client_sku_code = ''
      this.codeDialogVisible = true
    },
    // 保存
    singleLinkUpdateClientCode() {
      this.$api.productManagementApi.singleLinkUpdateClientCode(this.datas).then(res => {
        this.$message.success(res.msg)
        this.codeDialogVisible = false
        this.dialogVisible = false
        this.$parent.productList(this.$parent.datas);
      })

    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 30px;

  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 42px;
  }

  ul {
    background-color: #fff;
    min-height: 100px;
    padding: 5px 0;

    .template {
      display: flex;
      line-height: 36px;
    }

    /deep/.el-textarea__inner {
      height: 110px !important;
      width: 100% !important;
    }

    /deep/.el-upload-dragger {
      width: auto;
      height: auto;
      border: none;
    }

  }

  .file {
    width: 100%;

    .item {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      a {
        margin-right: 12px;
        flex: 1;
      }

      .el-icon-error {
        cursor: pointer;
        font-size: 16px;
        color: #B4272B;
        ;
      }
    }
  }

  .pic-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .img {
      position: relative;
      width: 50px;
      margin-right: 5px;

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:nth-last-child(1) {
            margin-left: 10px;
          }
        }
      }

      video {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }

  .bgc {
    background-color: rgba(250, 205, 145, 0.584313725490196);
  }
}

.nodata {
  text-align: center;
  padding: 30px;
  font-size: 20px;
}

.operation {
  margin-top: 24px;
}

/deep/ .el-textarea__inner {

  height: 100px;
}
</style>